export const transDate = (selectedDate: string) => {
  const [day, month, year] = selectedDate.split("/").map(Number);
  
  // Create date in local timezone
  const date = new Date(year, month - 1, day);
  date.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  if (date.getTime() === today.getTime()) return "Today";
  if (date.getTime() === tomorrow.getTime()) return "Tomorrow";

  return selectedDate;
}

export const formatToDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export const formatToTime = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Convert hours to 12-hour format and determine AM/PM
  const meridiem = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12; // Handle midnight (0 hours) as 12

  // Ensure minutes are always two digits long
  const formattedMinutes = String(minutes).padStart(2, '0');

  // Combine formatted hours, minutes, and meridiem
  return `${formattedHours}:${formattedMinutes}${meridiem}`;
}

export const dateToHumanFormat = (date: Date) => {
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  let selectedDate = date.toLocaleDateString()
  if(today.toDateString() === date.toDateString())
  selectedDate = "Today";
  if(tomorrow.toDateString() === date.toDateString())
    selectedDate = "Tomorrow";

  return `${selectedDate} at ${formatTime12Hours(date.getTime())}`;
}

export const formatTime12Hours = (dateStr: Date | string | number): string => {
  let date = new Date(dateStr);
  let hours = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  let period = 'AM';

  if (parseInt(hours) >= 12) {
    period = 'PM';
    if (hours !== '12')
      hours = String(parseInt(hours) - 12).padStart(2, '0');
  } else {
    if (hours === '00')
      hours = '12';
  }

  minutes = minutes.padStart(2, '0');
  return `${hours}:${minutes}${period}`;
}

export const formatTime24Hours = (time: string): string => {
  const [timeStr, period] = time.split(/(?=[AP]M)/);
  let [hours, minutes] = timeStr.split(':');

  if (period.toUpperCase() === 'PM') {
    if (hours !== '12')
      hours = String(parseInt(hours) + 12);
  } 
  // else {
  //   if (hours === '12')
  //     hours = '00';
  // }

  return `${hours}:${minutes}`;
}